import { useSubscription } from '@apollo/client';
import { useEventsCorrelation } from './useEventsCorrelation';

export const useConditionalSubscription = (scheme, options) => {
  const { retrieveCorrelation } = useEventsCorrelation();
  const { onData, mutationKey, ...restOptions } = options;

  const onConditionalSubscriptionData = event => {
    const { data } = event.data;
    const { headers } = data[Object.keys(data)[0]];

    if (!headers || !headers.nbbCorrelationId) {
      console.error(
        `CorrelationId is not found in the headers of the event received from endpoint '${scheme.definitions[0].name.value}'. The subscription effect will not be triggered.`
      );
      return;
    }

    const existing = retrieveCorrelation({ correlationId: headers.nbbCorrelationId, key: mutationKey });
    if (!existing) return;

    onData(event);
  };

  return useSubscription(scheme, { onData: onConditionalSubscriptionData, ...restOptions });
};
